import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/style.scss";
import "./langs/i18n";

ReactDOM.render(<App />, document.getElementById("root"));
